import { HttpParams } from '@angular/common/http';
import { Component,  Input, OnInit, Injector, Inject } from '@angular/core';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { Healthcareservice, HealthcareserviceSpecialists } from 'app/core/interfaces/healthcareservice';
import { BaseComponent } from '../../components/base.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { PractitionerroleService } from 'app/core/http/services/practitionerrole.service';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { Practitionerrole } from 'app/core/interfaces/practitionerrole';
import { Address } from 'app/core/interfaces/adress';
import { Location } from 'app/core/interfaces/location';

@Component({
  selector: 'schedule-specialist-by-organization',
  templateUrl: './schedule-specialist-by-organization.component.html',
  styleUrls: ['./schedule-specialist-by-organization.component.css']
})
export class ScheduleSpecialistByOrganizationComponent extends BaseComponent {


  @Input() position !: string 
  @Input() distance !: number;
  @Input() organization_id !: string;
  @Input() healthcareservice_id !: string;
  @Input() location !: Location

  public healthcareservices !: HealthcareserviceSpecialists[]

  public practitioners !: Practitioner[]
  public practitionerRoles: any[] = []

  public actor !: 'SECRETARY' | 'PATIENT'


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private procedureService: ProcedureService,
    private practitionerService: PractitionerService,
    private practitionerRoleService: PractitionerroleService,
    public injector: Injector) {
    super(injector)
   }

  ngOnInit(): void {

    if (this.data.param.position  && this.data.param.distance){
      this.distance = this.data.param.distance
      this.position = this.data.param.position
      this.organization_id  = this.data.param.organization_id
      this.healthcareservice_id = this.data.param.healthcareservice_id
      this.location = this.data.param.address

      this.actor = this.data.param.actor

      this.getHealthcareservicesNearest()
      this.getPractitioners()
      this.getPractitionerSpecilaties()

    }
  }

  getHealthcareservicesNearest() {
    this.healthcareservices = [];
    this.loading = true;

    let params = new HttpParams();

    params = params.set('position', this.position);
    params = params.set('radiusInMeters', this.distance);

    this.procedureService.listNearestBySpecialists(params).subscribe({
      next: (healthcareservices: HealthcareserviceSpecialists[]) => {

        this.healthcareservices = healthcareservices.filter( 
          healthcareservice => healthcareservice.organization_id == this.organization_id
          &&
          healthcareservice.healthcareservice_id == this.healthcareservice_id

        );
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        console.log(error);
      },
    });
  }

  getPractitioners() {
    this.practitionerService.listNew().subscribe({
      next: (res: Practitioner[]) => {
        this.practitioners = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  selectPractitioner(practitioner_id: string){
    return this.practitioners?.find( (practitioner: Practitioner) => practitioner.practitioner_id == practitioner_id)
  }

  selectPractitionerRole(practitioner_id : string){

    if (!this.practitionerRoles) return undefined

    return this.practitionerRoles?.find( (practitionerRole: Practitionerrole) => practitionerRole.practitioner_id == practitioner_id)
  }

  getPractitionerSpecilaties() {
    this.practitionerRoleService.list().subscribe({
      next: (res: any) => {
        this.practitionerRoles = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }




}
